'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import BeforeAfterSection from './BeforeAfterSection';
import SEOContentSection from './SEOContentSection';
import LeadCaptureSection from './LeadCaptureSection';
import WhyChooseSection from './WhyChooseSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import QuoteFormModal from './QuoteFormModal';

const HomepageInteractive = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const handleQuoteClick = () => {
    setIsQuoteModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsQuoteModalOpen(false);
  };

  return (
    <>
      <HeroSection onQuoteClick={handleQuoteClick} />
      <ServicesSection />
      <BeforeAfterSection />
      <SEOContentSection />
      <LeadCaptureSection />
      <WhyChooseSection />
      <TestimonialsSection />
      <CTASection onQuoteClick={handleQuoteClick} />
      <QuoteFormModal isOpen={isQuoteModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default HomepageInteractive;